module.exports = __webpack_public_path__ + "img/larke.dd27d15f.png";